import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';

import { Observable, of } from 'rxjs';
import * as fromStore from '@appStore/metering-points';
import * as fromInformationStore from '@core/store';
import * as fromProductsStore from '@appStore/products';

import { filter, take, switchMap } from 'rxjs/operators';


@Injectable()
export class MeteringPointsSelectedGuard  {
  constructor(
    private store: Store<fromStore.State>,
    private informationStore: Store<fromInformationStore.InformationState>,
    private productStore: Store<fromProductsStore.ProductsState>
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    let id = route.params['mpId'];

    this.productStore
      .select(fromProductsStore.getAllProducts)
      .pipe(
        filter(x => !x),
        take(1)
      )
      .subscribe(x => {
        this.store.dispatch(new fromProductsStore.ProductsLoad());
    });

    this.informationStore
      .select(fromInformationStore.getInformationLoaded)
      .pipe(
        filter(x => !x),
        take(1)
      )
      .subscribe(x => {
        this.informationStore.dispatch(new fromInformationStore.Load());
      });

    return this.store.select(fromStore.getMeteringPoints).pipe(
      filter(x => !!x && x.length > 0),
      switchMap(_ =>
        this.store.select(fromStore.getSelectedMeteringPoint).pipe(
          switchMap(mp => {
            if (mp) {
              // if the metering point is already selected, we can return true
              if (id && +id > 0 && mp.id === +id) {
                return of(true);
              }
              else if (id && +id > 0 && mp.id !== +id) {
                this.store.dispatch(new fromStore.SelectMeteringPointById(+id));
                return of(true);
              }

              return of(true);
            } else if (id && +id > 0) {
              this.store.dispatch(new fromStore.SelectMeteringPointById(+id));

              return of(true);
            }
            return of(false);
          })
        )
      )
    );
  }
}
